import {gql} from "graphql-tag";
import {responseField} from "../../../base.graphql";
import {paginationFields} from "../geographical-zone/geographical-zone.graphql";

const sensorAlertConfigFields = `
      alertReceivers {
        alert
        level
        receiver
      }
      id
      uniqueId
      sensor
      minTemperature
      maxTemperature
      minHumidity
      maxHumidity
      occurenceCircles
      circlesToEscalation
      escalationPeriod
`;

// MUTATIONS
export const CREATE_SENSOR_ALERT_CONFIG_MUTATION = gql`
    mutation CreateSensorAlertConfigMutation($input: AlertSettingsInputObject!) {
        createSensorAlertConfigMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${sensorAlertConfigFields}
            }
        }
    }
`;

export const UPDATE_SENSOR_ALERT_CONFIG_MUTATION = gql`
    mutation UpdateSensorAlertConfigMutation($input: AlertSettingsInputObject!) {
        updateSensorAlertConfigMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${sensorAlertConfigFields}
            }
        }
    }
`;

export const DELETE_SENSOR_ALERT_CONFIG_MUTATION = gql`
    mutation DeleteSensorAlertConfigMutation($uniqueId: String!) {
        deleteSensorAlertConfigMutation(uniqueId: $uniqueId) {
            response {
                ${responseField}
            }
        }
    }
`;

//QUERIES
export const GET_SENSOR_ALERT_CONFIG_QUERY = gql`
    query GetSensorAlertsConfig($filtering: AlertSettingsFilteringObject!) {
        getSensorAlertsConfig(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${sensorAlertConfigFields}
            }
            page {
                ${paginationFields}
            }
        }
    }
`;